(function () {
  'use strict';

  var BREAKPOINTS = [0.00, 0.10, 0.25, 0.40, 0.56, 0.72, 0.87];
  var COUNTER_DURATION = 1800;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function waitForGSAP(cb, attempts) {
    attempts = attempts || 0;
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      cb();
    } else if (attempts < 60) {
      setTimeout(function () { waitForGSAP(cb, attempts + 1); }, 100);
    }
  }

  function animateCounters(counters) {
    counters.forEach(function (el) {
      var target = parseInt(el.dataset.target, 10) || 0;
      var startTime = performance.now();
      function tick(now) {
        var elapsed = now - startTime;
        var progress = Math.min(elapsed / COUNTER_DURATION, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased);
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  function init() {
    var section  = document.getElementById('lab-ai-experience');
    if (!section) return;

    var videos   = Array.from(section.querySelectorAll('.lab-ai__video'));
    var overlays = Array.from(section.querySelectorAll('.lab-ai__overlay'));
    var counters = Array.from(section.querySelectorAll('.lab-ai__counter-value'));

    if (!videos.length) return;

    var currentAct   = 0;
    var countersDone = false;

    function getTargetAct(progress) {
      var target = 0;
      for (var i = BREAKPOINTS.length - 1; i >= 0; i--) {
        if (progress >= BREAKPOINTS[i]) { target = i; break; }
      }
      return target;
    }

    function showAct(nextAct) {
      if (nextAct === currentAct) return;

      videos[currentAct].classList.remove('lab-ai__video--active');
      if (overlays[currentAct]) overlays[currentAct].classList.remove('lab-ai__overlay--active');

      if (currentAct === 0) videos[0].loop = false;
      if (nextAct === 0) videos[0].loop = true;

      currentAct = nextAct;

      videos[nextAct].classList.add('lab-ai__video--active');
      if (overlays[nextAct]) overlays[nextAct].classList.add('lab-ai__overlay--active');

      if (nextAct === 0) {
        videos[0].play().catch(function () {});
      } else {
        videos[nextAct].currentTime = 0;
        videos[nextAct].play().catch(function () {});
      }

      if (nextAct === 5 && !countersDone) {
        animateCounters(counters);
        countersDone = true;
      }
    }

    if (reducedMotion) { showAct(1); return; }

    gsap.registerPlugin(ScrollTrigger);

    ScrollTrigger.create({
      trigger  : section,
      start    : 'top top',
      end      : 'bottom bottom',
      scrub    : false,
      onUpdate : function (self) {
        var target = getTargetAct(self.progress);
        if (target !== currentAct) showAct(target);
      },
      onRefresh: function (self) {
        var target = getTargetAct(self.progress);
        if (target !== currentAct) showAct(target);
      }
    });

    window.addEventListener('resize', function () { ScrollTrigger.refresh(); });

    var preloadIdx = 1;
    function preloadNext() {
      if (preloadIdx >= videos.length) return;
      var v = videos[preloadIdx];
      if (v.getAttribute('preload') === 'none') {
        v.setAttribute('preload', 'auto');
        v.load();
      }
      preloadIdx++;
      if (preloadIdx < videos.length) setTimeout(preloadNext, 2000);
    }
    setTimeout(preloadNext, 2500);
  }

  function boot() { waitForGSAP(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();


